import { render, staticRenderFns } from "./DealCorrections.vue?vue&type=template&id=2a83d14e&"
import script from "./DealCorrections.vue?vue&type=script&lang=ts&"
export * from "./DealCorrections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports